// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3uk7Z0fcdl_header-footer"};